import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "./Reveal";

export default function Manifesto() {
  const { t } = useLang();

  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#081b34", color: "#fff" }}
    >
      {/* Subtle grid background */}
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.05) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          maskImage:
            "radial-gradient(ellipse at center, rgba(0,0,0,0.7), transparent 75%)",
        }}
      />

      <div className="sap-container relative">
        <Reveal>
          <div className="flex items-center gap-3 mb-8">
            <span className="sap-divider-gold" />
            <span
              className="text-[11px] uppercase tracking-[0.32em]"
              style={{ color: "var(--sap-gold)" }}
            >
              {t.manifesto.overline}
            </span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-6" delay={100}>
            <h2
              className="font-serif leading-[1.08] tracking-tight"
              style={{
                fontSize: "clamp(2rem, 4vw, 3.6rem)",
                fontWeight: 400,
              }}
            >
              {t.manifesto.title}
            </h2>
          </Reveal>

          <div className="lg:col-span-6 space-y-6">
            {t.manifesto.lines.map((line, i) => (
              <Reveal key={i} delay={150 + i * 80}>
                <p className="text-[15px] md:text-base leading-relaxed text-white/75">
                  {line}
                </p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={500}>
          <div
            className="mt-16 md:mt-20 border-l-2 pl-8 md:pl-10 max-w-4xl"
            style={{ borderColor: "var(--sap-gold)" }}
          >
            <blockquote
              className="font-serif italic leading-[1.15]"
              style={{
                fontSize: "clamp(1.6rem, 3vw, 2.6rem)",
                color: "#fff",
                fontWeight: 400,
              }}
            >
              “{t.manifesto.quote}”
            </blockquote>
            <div
              className="mt-6 text-[11px] tracking-[0.3em] uppercase"
              style={{ color: "var(--sap-gold)" }}
            >
              {t.manifesto.quote_author}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
